import { Api } from "../api/api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class BirthdayChangeProvider {
  private url: string = "me/birthday";

  constructor(public http: HttpClient, public api: Api) {}

  put(birthday: string): Observable<any> {
    return this.api.put(this.url, { birthday });
  }
}



// WEBPACK FOOTER //
// ./src/providers/birthday-change/birthday-change.ts